<div 
    (click)="onClickArea$.emit(eventData)"
    [ngClass]="{
        'enter': eventData.EA === EVENT_TYPE.EventAreaEnter,
        'exit': eventData.EA === EVENT_TYPE.EventAreaExit
    }"
    class="item"
>
    <div class="item__left">
        <img class="enter-img" src="/assets/img/area-enter-event.svg" alt="">
        <img class="exit-img" src="/assets/img/area-exit-event.svg" alt="">
    </div>
    <div class="item__right">
        <span class="item__title">
            {{ eventData?.ED?.Nm || 'Nieznany obszar' }}
        </span>
        <span class="item__desc">
            <tk-event-list-alarm-item-info [event]="eventData"></tk-event-list-alarm-item-info>
        </span>
    </div>
    <span class="item__time">
        {{ eventData.TS | date : 'HH:mm' }}
    </span>
</div>
